import L from 'leaflet'
import 'leaflet.vectorgrid'
// скопировал из node_modules/leaflet-plugins/layer/tile/Yandex и добавил условие на 108 строке
import '@/assets/plugins/leaflet-plugins/layer/tile/Yandex'

import { atu, map as mapEndpoints } from '@/api/api-endpoints'
import { OBJECT } from '@/utils/map/types'
import { MARKER_ICON } from '@/config/map'
import ObjectCardLinkCreator from '@/utils/map/layer/ObjectCardLinkCreator'
import { WALL } from '@/config/config'
import MappingDrawer from '../utils/MappingDrawer'
import MappingBorderDrawer from '../utils/MappingBorderDrawer'
import { REGION_CONFIG } from '@/config/regions'
import { getDifferenceInArrays } from '@/utils'
import { COLORS } from '@/utils'

const rosreestr_prefix = 'https://pkk.rosreestr.ru/'

export default {
  data() {
    return {
      selectedMappingObject: ' ',
      selectedMappingObjectZoom: null,
      showEquidistantGeo: null,
      radiusEquidistant: null,
      radiusEquidistantGeo: 1000,
      equidistantPoint: {
        id: 'click',
        type: OBJECT.EQUIDISTANT,
        lat: undefined,
        lng: undefined,
      },
      cadastreTile: null,
      legendItems: null,
      rosreestrTiles: {
        cadastreLines: new L.LayerGroup([
          new L.VectorGrid.Protobuf(
            rosreestr_prefix +
              'arcgis/rest/services/Hosted/caddivsion/VectorTileServer/tile/{z}/{y}/{x}.pbf',
            {
              rendererFactory: L.svg.tile,
              interactive: false,
              pane: 'cadastre',
              minZoom: 3,
              vectorTileLayerStyles: {
                'Кадастровые округа:1': {
                  weight: 1,
                  fillOpacity: 1,
                  fillColor: '#d20305',
                  color: '#d20305',
                },
                'Кадастровые округа:2': {
                  weight: 1,
                  fillOpacity: 1,
                  fillColor: '#d20305',
                  color: '#d20305',
                },
                'Кадастровые районы:1': {
                  weight: 1,
                  fillOpacity: 1,
                  fillColor: '#d20305',
                  color: '#d20305',
                },
                'Кадастровые районы:2': {
                  weight: 1,
                  fillOpacity: 1,
                  fillColor: '#d20305',
                  color: '#d20305',
                },
                'Кадастровые кварталы': {
                  weight: 1,
                  fillOpacity: 1,
                  fillColor: '#d20305',
                  color: '#d20305',
                },
                'Кадастровые округа:1/label': {
                  stroke: false,
                },
                'Кадастровые округа:2/label': {
                  stroke: false,
                },
                'Кадастровые районы:1/label': {
                  stroke: false,
                },
                'Кадастровые районы:2/label': {
                  stroke: false,
                },
                'Кадастровые кварталы/label': {
                  stroke: false,
                },
              },
            }
          ),
        ]),
        osm: new L.LayerGroup([], { pane: 'osm' }),
        yandex: new L.LayerGroup([L.yandex()], { pane: 'yandex' }),
        satellite: new L.LayerGroup([L.yandex('yandex#satellite')], {
          pane: 'yandex',
        }),
      },
    }
  },
  computed: {
    mappingConfObject() {
      return REGION_CONFIG.filterMenu
    },
    mappingCurrentLegend() {
      let currentOnZoom = null
      if (this.selectedMappingObject && this.selectedMappingObjectZoom) {
        let zoom = this.selectedMappingObjectZoom
        let current = this.mappingConfObject[this.selectedMappingObject]
        if (!current) {
          return {}
        }
        current.legends.forEach((v) => {
          if (
            v.hasOwnProperty('showOnZoom') &&
            v.showOnZoom.indexOf(zoom) > -1
          ) {
            currentOnZoom = v
          } else if (!currentOnZoom) {
            currentOnZoom = v
          }
          if (currentOnZoom) {
            if (!v.title) {
              currentOnZoom.title = current.title
            }
            currentOnZoom.items.forEach((item, i) => {
              currentOnZoom.items[i].style = Object.assign(
                currentOnZoom.items[i].style || {},
                v.style || {}
              )
            })
          }
        })
      }

      return currentOnZoom || {}
    },
    radius() {
      return this.radiusEquidistant
    },
    yearSelectorStyles() {
      let style = {}
      if (this.selectedMappingObject == 'formed') {
        style.left = '300px'
      }
      return style
    },
  },
  mounted() {
    this.mappingDrawer = new MappingDrawer(this.map, this)
    this.map.createPane('cadastre')
    this.map.createPane('osm')
    this.map.createPane('yandex')
    this.$emitter.listen('searchRosreestr', this.searchRosreestr)
    this.$emitter.listen('whatisit', ({ latlng: { lat, lng } }) =>
      this.searchRosreestr(`${lat},${lng}`)
    )
    this.$emitter.listen(
      'copyObjectCardLinkToClipboard',
      ({ id, subLayerConfig }) => {
        this.copyObjectCardLinkToClipboard(id, subLayerConfig)
      }
    )
    this.$emitter.listen('eqClickPolygon', (polygon) =>
      this.modifyEqPolygon(polygon)
    )
    this.setMappingObjectFromRoute()
  },
  methods: {
    copyObjectCardLinkToClipboard(id, subLayerConfig) {
      const link = ObjectCardLinkCreator.createLink(id, subLayerConfig)
      link &&
        navigator.clipboard.writeText(link).then(() => {
          this.$message({
            message: 'Ссылка скопирована в буфер',
            type: 'success',
            duration: WALL.SUCCESS_TIMEOUT,
          })
        })
    },
    async modifyEqPolygon(polygon) {
      if (!this.showEquidistantGeo) {
        await this.borderDrawer.clearEqPoly()
        return
      }
      //TODO поставить debugger для отладки Эквидистанты населенного пункта
      const data = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: atu.equidistant(polygon.id, this.radiusEquidistantGeo),
      })
      await this.borderDrawer.clearEqPoly()
      this.borderDrawer.drawPolygon(data.data)
      this.borderDrawer.addEqPolygonClick(polygon.id, this.radiusEquidistantGeo)
    },
    setEquidistantGeo(value) {
      this.radiusEquidistantGeo = value
    },
    setShowEquidistantGeo(show) {
      this.showEquidistantGeo = show
    },
    async searchRosreestr(q) {
      try {
        await this.getInfoFromRosreestr(q).then(({ data }) => {
          if (!data || data.lat === 0.0) {
            this.$e.warningBox('Ничего не найдено')
            return
          }
          this.$e.warningBox(
            `Осталось ${data.queryAttempts} запросов на сегодня. Запросы расходуются при поиске по адресу или координатам в Росреестре. `
          )
          this.openRosreestrPopup(data)
        })
      } catch (e) {
        this.$e.errorBox(e)
      } finally {
        this.$bar.finish()
      }
    },
    openRosreestrPopup(data) {
      if (!this.map) {
        return
      }
      const latLng = L.latLng(data.lat, data.lng)
      const marker = L.marker(latLng, {
        icon: MARKER_ICON,
      })

      if (this.map.getZoom() >= 17) {
        this.map.panTo(latLng)
      } else {
        const markerBounds = L.latLngBounds([marker.getLatLng()])
        this.map.fitBounds(markerBounds, { maxZoom: 17 })
      }

      const popup = L.popup({
        maxWidth: 1000,
        maxHeight: 1000,
        className: 'tooltip tooltip--top',
        bottomOffset: 50,
      })
        .setLatLng(latLng)
        .setContent(this.composeRosreestrPopupContent(data))
      marker.bindPopup(popup).addTo(this.map).openPopup()
    },
    composeRosreestrPopupContent(data) {
      let result = `<p>
                  <h1>${data.address || data.type + ', адрес не найден'}</h1>
                   Кадастровый номер: <b>${data.cadasterNumber || ' - '}</b><br>
                   Тип: <b>${data.type || ' - '}</b><br>
                   Координаты: <b>${data.lat + ', ' + data.lng}</b><br>`
      if (data.area) {
        result += `Площадь: <b>${data.area}</b><br>`
      }
      result += '</p>'
      return result
    },
    async getInfoFromRosreestr(q) {
      return await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.searchRosreestr({ query: { q } }),
      })
    },
    updateEquidistantCircle(radius) {
      this.radiusEquidistant = radius
    },
    drawBorders() {
      this.borderDrawer = new MappingBorderDrawer(this.map, this)
      this.borderDrawer.drawAll(this.getMapPolygon(), this.mapBorders)
      this.borderDrawer.drawLocality(this.mapBorders, true)
    },
    async onMappingCurrentLegend() {
      this.borderDrawer = new MappingBorderDrawer(this.map, this)
      this.mappingDrawer.clearPoly()
      this.borderDrawer.detachPopups()
      await this.fetchMappingLegendData(this.mappingCurrentLegend).then(() => {
        this.borderDrawer.attachPopups(this.mappingCurrentLegend)
      })
    },
    async fetchMappingLegendData(legend) {
      if (!legend?.endpoint) {
        this.mappingLock()
        this.mappingDrawer.clearPoly()
        this.mappingUnLock()
        return Promise.resolve()
      }

      const endpoint =
        typeof legend?.endpoint === 'function'
          ? legend.endpoint(this.$route)
          : legend.endpoint
      if (this.mappingDrawer.isPolyDrawed(endpoint)) {
        return
      }
      this.mappingLock()
      let data = this.$store.getters.readUrlEndpoint(endpoint)
      if (!data) {
        this.$bar.start()
        const res = await this.$store.dispatch('updateUrlEndpoint', {
          endpoint,
          notReactive: true,
        })
        data = res.data
        this.$bar.finish()
      }
      try {
        const filteredObjects = this.filterGeoObjects(data)
        const relatedObjects = await this.foundRelatedRegions(filteredObjects)
        this.mappingDrawer.clearPoly()
        this.mappingDrawer.setRelatedObjects(relatedObjects)
        this.mappingDrawer.setPolyData(filteredObjects, legend, endpoint)
      } catch (e) {
        console.error(e)
        this.$store.commit('mutateError', e)
      }
      this.mappingUnLock()
    },
    async foundRelatedRegions(data) {
      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.threads(this.$route),
      })

      const relations = response.data.data
      this.mappingDrawer.setRelations(relations)

      const objects = []
      if (!data || !relations) {
        return []
      }
      const names = data.map((el) => el.name_with_type)
      for (let i = 0; i < data.length; i++) {
        const element = data[i]
        for (let j = 0; j < relations.length; j++) {
          const item = relations[j]
          if (item.end.full_name.includes(element.name_with_type)) {
            let object = this.heatMapFormedDistrict.find(
              (el) => el.name_with_type === item.start.name
            )
            if (!object) {
              object = this.objects?.find(
                (el) => el.name_with_type === item.start.name
              )
            }
            if (object && !names.includes(object.name_with_type)) {
              objects.push(object)
            }
          }
        }
      }
      return objects
    },
    filterGeoObjects(data) {
      if (!data) {
        return []
      }
      let filteredObjects = []
      let allObjects = this.objects

      if (this.hasDefaultColorToInfrastructure) {
        allObjects = this.$store.getters.readUrlEndpoint(
          atu.atuObjectUpdateOrCreate()
        )?.data
      }

      filteredObjects = getDifferenceInArrays(
        allObjects,
        data,
        'name_with_type'
      )
      filteredObjects = filteredObjects.map((item) => {
        const geojson = JSON.parse(JSON.parse(JSON.stringify(item.geo_json)))
        return {
          ...item,
          sum_power: -1,
          geojson: JSON.stringify({
            coordinates: geojson?.coordinates,
          }),
        }
      })
      const result = [...filteredObjects, ...data]
      return result
    },
    mappingLock() {
      this.lockRoute()
      this.layersLoading = true
    },
    mappingUnLock() {
      this.layersLoading = false
      this.unLockRoute()
      this.updateRouteStateFromMap()
    },
    async setSelectedMappingObject(v) {
      if (v) {
        this.selectedMappingObject = v
      }
      if (!v) {
        await this.replaceRoute({ selectedMappingObject: null })
        this.selectedMappingObject = ''
        await this.onMappingCurrentLegend()
        return
      }
      v = v.trim()
      await this.replaceRoute({ selectedMappingObject: v })
      const endpoint = mapEndpoints.mapLegend(v, this.$route.query.zoom)

      if (this.$route.query.selectedMappingObject === 'infrastructure') {
        let word = 'утилизации'
        let ending = 'утилизации'
        switch (this.$route.query.infrastructureAction) {
          case 'burial':
            word = 'захоронения'
            ending = 'захоронению'
            break
          case 'storage':
            word = 'хранения'
            ending = 'хранению'
            break
          case 'neutralization':
            word = 'обезвреживание'
            ending = 'обезвреживанию'
            break
          case 'utilization':
            word = 'утилизации'
            ending = 'утилизации'
            break
          case 'processing':
            word = 'обработки'
            ending = 'обработке'
            break
          case 'transportation':
            word = 'транспортирования'
            ending = 'транспортированию'
            break
          case 'collection':
            word = 'сбора'
            ending = 'сбору'
            break
          default:
            word = 'утилизации'
            ending = 'утилизации'
        }
        this.legendItems = [
          {
            color: COLORS.purple,
            id: 0,
            max: 0,
            min: 1,
            title: `Совокупная мощность объектов ${word} в районе < Совокупные отходы, подлежащие ${ending} в районе`,
          },
          {
            color: COLORS.yellow,
            id: 1,
            max: 49,
            min: 30,
            title: `Совокупная мощность объектов ${word} в районе > Совокупные отходы, подлежащие ${ending}  в районе на 30%`,
          },
          {
            color: COLORS.lightGreen,
            id: 2,
            max: 89,
            min: 50,
            title: `Совокупная мощность объектов ${word} в районе > Совокупные отходы, подлежащие ${ending}  в районе на 50%`,
          },
          {
            color: COLORS.green,
            id: 3,
            max: 99,
            min: 90,
            title: `Совокупная мощность объектов ${word} в районе > Совокупные отходы, подлежащие ${ending}  в районе на 90%`,
          },
          {
            color: COLORS.red,
            id: 4,
            max: 100,
            min: 100,
            title: `Совокупная мощность объектов ${word} в районе > Совокупные отходы, подлежащие ${ending}  в районе`,
          },
          {
            color: COLORS.grey,
            id: 5,
            min: -1,
            title: `Рассматриваемый вид объектов отсутствует в этом районе`,
          },
        ]
        if (this.hasCustomInfrastructure) {
          this.legendItems = REGION_CONFIG.updateInfrastructureLegend({
            word,
            ending,
          })
        }
        await this.onMappingCurrentLegend()
        return false
      }
      if (endpoint) {
        this.$store
          .dispatch('updateUrlEndpoint', {
            endpoint,
            notReactive: true,
            fromCache: true,
          })
          .then((res) => (this.legendItems = res.data.data))
      }
      await this.onMappingCurrentLegend()
    },
    setMappingObjectFromRoute() {
      this.setSelectedMappingObject(this.$route?.query?.selectedMappingObject)
      this.selectedMappingObjectZoom = Number.parseInt(
        this.$route.query.zoom || this.map.getZoom() * 1
      )
    },
    // клик по карте от Эквидистанты ..
    equidistantEventClick(e) {
      this.equidistantPoint.lat = e.latlng.lat
      this.equidistantPoint.lng = e.latlng.lng

      this.mappingDrawer.removeMarker(this.equidistantPoint)
      this.mappingDrawer.removeCircle(this.equidistantPoint)
      this.mappingDrawer.drawMarker(this.equidistantPoint)
      this.mappingDrawer.drawCircle(
        this.equidistantPoint,
        parseInt(this.radius, 10)
      )
    },
    // вызов попопа по контекстному меню ...
    equidistantEventContextmenu() {
      // точку не поставили .. надо выйти ...
      if (
        typeof this.equidistantPoint.lat == 'undefined' ||
        typeof this.equidistantPoint.lng == 'undefined'
      ) {
        return
      }
      this.mappingDrawer.removeMarker(this.equidistantPoint)
      const marker = this.mappingDrawer.drawMarker(this.equidistantPoint)
      marker.type = OBJECT.EQUIDISTANT
      marker.options.popupOptions = {
        redirectParams: {
          name: 'equidistant.object',
          query: {
            radius: this.radius,
            longitude: this.equidistantPoint.lng,
            latitude: this.equidistantPoint.lat,
            layers: this.$route.query.layers,
          },
        },
      }
      this.mappingDrawer.createPopup(marker)
    },
    onShowEquidistant(show) {
      if (show) {
        this.map.on('click', this.equidistantEventClick)
        this.map.on('contextmenu', this.equidistantEventContextmenu)
      } else {
        this.map.off('click', this.equidistantEventClick)
        this.map.off('contextmenu', this.equidistantEventContextmenu)
        this.mappingDrawer.removeMarker(this.equidistantPoint)
        this.mappingDrawer.removeCircle(this.equidistantPoint)
        this.equidistantPoint.lat = this.equidistantPoint.lng = undefined
      }
    },
    onRosreestrChangeView(value) {
      switch (value) {
        case 'rosreestr_cadastre': {
          this.map.hasLayer(this.rosreestrTiles.osm) &&
            this.map.removeLayer(this.rosreestrTiles.osm)
          this.map.hasLayer(this.rosreestrTiles.yandex) &&
            this.map.removeLayer(this.rosreestrTiles.yandex)
          this.map.removeLayer(this.rosreestrTiles.satellite)
          this.map.addLayer(this.rosreestrTiles.cadastreLines)
          this.map.getPane('osm').style.display = 'none'
          this.map.getPane('yandex').style.display = 'none'
          this.map.getPane('cadastre').style.display = 'block'
          break
        }

        case 'osm': {
          this.map.removeLayer(this.rosreestrTiles.yandex)
          this.map.removeLayer(this.rosreestrTiles.satellite)
          this.map.addLayer(this.rosreestrTiles.osm)
          this.map.getPane('cadastre').style.display = 'none'
          this.map.getPane('yandex').style.display = 'none'
          this.map.getPane('osm').style.display = 'block'
          break
        }
        case 'yandex': {
          this.map.removeLayer(this.rosreestrTiles.osm)
          this.map.removeLayer(this.rosreestrTiles.satellite)
          this.map.addLayer(this.rosreestrTiles.yandex)
          this.map.getPane('cadastre').style.display = 'none'
          this.map.getPane('osm').style.display = 'none'
          this.map.getPane('yandex').style.display = 'block'
          break
        }
        case 'satellite': {
          this.map.removeLayer(this.rosreestrTiles.osm)
          this.map.removeLayer(this.rosreestrTiles.yandex)
          this.map.addLayer(this.rosreestrTiles.satellite)
          this.map.getPane('cadastre').style.display = 'none'
          this.map.getPane('osm').style.display = 'none'
          this.map.getPane('yandex').style.display = 'block'
          break
        }
      }
    },
    addYandexTile() {
      this.map.addLayer(this.rosreestrTiles.yandex)
    },
  },
}
